<template>
    <div class="col-12 pointSection" v-if="user">
        <div class="pointsTitle h2 ktdarkchoc text-center">
            <span v-if="!nextreward">Your available points</span><br><span>{{ availablePoints }}</span><span v-if="nextreward"> / {{ nextreward }}</span>
        </div>
        <div class="frame">
            <img :src="getStaticImage('icons/home/bublicdesk.png')">
        </div>
        <div class="alert h4 text-center" v-if="nextreward">
            <span>{{ pointsuntil }}</span> Point<span v-if="pointsuntil > 1">s</span>  until your next FREE reward!
        </div>
        <div class="disclamer caption">
            Points can take 24 hours to be added
        </div>
    
        <div class="cardsManageSection home mb-5">
            <div class="kettlCardsBox">
                <div class="descktopMediaBox">
                    <div class="h2">
                        Wallet
                    </div>
                </div>
                <MyWallet/>
            </div>
        </div>
        
        <div class="descktopMediaBox">
            <div class="h2">
                My Rewards
            </div>
        </div>
        <div class="pointsList">
            <div class="pontEl"
                 v-for="offer in rewards.offers"
                 v-if="!!offer.redeemable">
                <div class="frame">
                    <img :src="offer.offer_photo">
                </div>
                <div class="title h4">
                    {{ offer.offer_title.replace(/<[^>]*>?/gm, ' ')}}
                    <span class="smpoints" v-if="offer.purchase_amount">{{offer.purchase_amount}} pts</span>
                </div>
                <div @click="setOffer(offer)"  class="points h4">
                    <span>
                         CLAIM REWARD
                    </span>
                </div>
            </div>
        </div>
        <div class="descktopMediaBox">
            <div class="h2">
                Rewards History
            </div>
            <div class="historyList" v-if="rewHistList">
                <div class="el" v-for="elment in rewHistList">
                    <div class="leftCol">
                        <div class="date h5">
                            {{ dateTransform(elment.added) }}
                        </div>
                        <div class="title">
                            {{ elment.business_name }}
                        </div>
                    </div>
                    <div class="minusPoints caption">
                        {{ elment.points }}pts
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MyWallet from "../checkout/MyWallet";
    import moment from "moment";
    
    
    export default {
        name: "RewardsList",
        components: {MyWallet},
        data() {
            return {
                rewards: [],
                availablePoints: null,
                nextreward: null,
                pointsuntil: null,
                rewHistList: null,
                orderTypes: ['accept', 'event', 'import', 'logpurchase', 'order', 'profile', 'redeem', 'referral', 'refund', 'reward', 'reward_voided', 'sign_in', 'survey', 'transfer' ]
            }
        },
        created() {
            this.$store.dispatch("cart/getUserLoyaltyProfile",{
                callback: (res) => {
                    this.rewards = res.data;
                    this.rewards.offers = this.rewards.offers.filter(o=>o.redeemable)
                    this.availablePoints = res.data.available_points;
                    let rewAmountArray = [];
                    let cur_point = this.availablePoints;
                    this.rewards.offers.map(el=>{
                        if(el.purchase_amount>0){
                            rewAmountArray.push(el.purchase_amount);
                        }
                    })
                    rewAmountArray = unique(rewAmountArray.sort((a, b) => a - b));

                    let closestLeft,
                    closestRight,
                    data = rewAmountArray,
                    number = cur_point,
                    current;
                    for (var i = 0; i < data.length; i++) {
                        current = data[i];
                        if (current < number && (typeof closestLeft === 'undefined' || closestLeft < current)) {
                            closestLeft = current;
                        } else if (current > number && (typeof closestRight === 'undefined' || closestRight > current)) {
                            closestRight = current;
                        }
                    }
                    this.nextreward = closestRight;
                    if(closestRight){
                        this.pointsuntil = closestRight - cur_point;
                    }
                }
            });
            this.$store.dispatch("cart/getUserLoyaltyHistory", {
                callback: (res) => {
                    //console.log(res.data)
                    this.rewHistList = res.data;

                    this.rewHistList = this.rewHistList.filter(o =>{
                        if (this.orderTypes.includes(o.object_type)){
                            o.points = (+o.points >=0) ? `+${o.points}` : `${o.points}`
                            return  true;
                        }else {
                            return false
                        }
                    })
                }
            })
        },
        methods:{
            dateTransform(date) {
                return moment(date).format("MMM DD [AT] h:mm a")
            },
            setOffer(offer){
                this.$store.commit('cart/setTempOffer', {offer});
                this.$router.push({name: 'Locations'});
            }
        }
    }
    function unique(arr) {
        let result = [];

        for (let str of arr) {
            if (!result.includes(str)) {
                result.push(str);
            }
        }
        return result;
    }
    
</script>

